module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Graham E Howarth is a retired primary school head teacher who lives in Bury, Lancashire.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He is married to Helen and has two daughters, Sarah and Kate.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('em', [_vm._v("Alliance")]), _vm._v(" is the first novel in his "), _c('em', [_vm._v("Far Future")]), _vm._v(" trilogy that moves on to "), _c('em', [_vm._v("Containment")]), _vm._v(" and then "), _c('em', [_vm._v("Infinity")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He has also written his autobiography, "), _c('em', [_vm._v("If Only I’d Asked")]), _vm._v(", plus "), _c('em', [_vm._v("The Burrs Country Park, Bury")]), _vm._v(", a record in poems and pictures, including a brief history of the park. Both have been self-published for local sale"), _c('em', [_vm._v(". A History of The Burrs, Bury")]), _vm._v(" will also be published locally in 2022.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He has been a science fiction aficionado for many years.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0